export const themes = ["Nature", "History", "Food", "Adventure", "Sea", "Culture"];

export const seedProvinces = [
  {
    id: "trabzon",
    name: "Trabzon",
    slogan: "Sis, yayla ve sahil aynı günde.",
    story:
      "Trabzon’da bir sabah sahilde çay içip öğleden sonra yaylada bulutlara dokunursun. Tarih, Karadeniz’in hırçın rüzgarıyla taş sokaklarda fısıldar; sofrada mısır ekmeği, tereyağı ve hamsiyle tamamlanır. Burada keşif hızlı başlar ama hatıralar yavaş yerleşir.",
    heroImage: null,
    themes: ["Nature", "History", "Food", "Sea", "Culture"],
    highlights: [
      {
        id: "h-trabzon-1",
        title: "Sümela Manastırı",
        shortDescription: "Kayalığa asılı bir tarih yürüyüşü.",
        theme: "History",
        locationHint: "Maçka",
        bestSeason: "Autumn",
      },
      {
        id: "h-trabzon-2",
        title: "Uzungöl",
        shortDescription: "Göl kıyısında sisli bir kaçamak.",
        theme: "Nature",
        locationHint: "Çaykara",
        bestSeason: "Spring",
      },
    ],
    experiences: [
      {
        id: "e-trabzon-1",
        title: "Yayla rotası",
        shortDescription: "Kısa yürüyüş + fotoğraf noktaları.",
        theme: "Adventure",
        locationHint: "Hıdırnebi",
        bestSeason: "Summer",
      },
    ],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },
  {
    id: "rize",
    name: "Rize",
    slogan: "Çayın kokusu, yağmurun ritmi.",
    story:
      "Rize’de yağmur bir engel değil; manzaranın parçasıdır. Çay bahçeleri basamak basamak yükselir, her viraj yeni bir yeşil tonudur. Ayder’in buharı, derelerin sesi ve yayla yolları günün planını kendiliğinden çizer.",
    heroImage: null,
    themes: ["Nature", "Food", "Adventure", "Culture"],
    highlights: [
      {
        id: "h-rize-1",
        title: "Ayder Yaylası",
        shortDescription: "Kaplıca buharı ve yayla havası.",
        theme: "Nature",
        locationHint: "Çamlıhemşin",
        bestSeason: "Winter",
      },
      {
        id: "h-rize-2",
        title: "Fırtına Vadisi",
        shortDescription: "Rafting ve köprü manzaraları.",
        theme: "Adventure",
        locationHint: "Ardeşen",
        bestSeason: "Spring",
      },
    ],
    experiences: [
      {
        id: "e-rize-1",
        title: "Taş köprüler turu",
        shortDescription: "Kısa rotada 3 köprü.",
        theme: "Culture",
        locationHint: "Fırtına",
        bestSeason: "Spring",
      },
    ],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },
  {
    id: "artvin",
    name: "Artvin",
    slogan: "Vadi derin, hikaye daha derin.",
    story:
      "Artvin, Karadeniz’in en vahşi ve en sakin yüzünü aynı karede sunar. Vadiler birdenbire derinleşir, ormanlar göğe yaklaşır. Her köy yolu bir keşif; her molada kuş sesleriyle dinlenen bir nefes.",
    heroImage: null,
    themes: ["Nature", "Adventure", "Culture"],
    highlights: [
      {
        id: "h-artvin-1",
        title: "Karagöl",
        shortDescription: "Sakin göl manzarası, kısa yürüyüş.",
        theme: "Nature",
        locationHint: "Borçka",
        bestSeason: "Autumn",
      },
    ],
    experiences: [
      {
        id: "e-artvin-1",
        title: "Vadi rotası",
        shortDescription: "Araç + kısa yürüyüş kombinasyonu.",
        theme: "Adventure",
        locationHint: "Borçka",
        bestSeason: "Autumn",
      },
    ],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },
  {
    id: "samsun",
    name: "Samsun",
    slogan: "Kıyıda şehir, içeride tarih.",
    story:
      "Samsun’da sahil bandı gün boyu yaşar; biraz içeri gidince ise tarih anlatmaya başlar. Geniş parklar, uzun yürüyüşler ve müzeler; Karadeniz temposunu şehir rahatlığıyla birleştirir.",
    heroImage: null,
    themes: ["Sea", "History", "Culture", "Food"],
    highlights: [
      {
        id: "h-samsun-1",
        title: "Bandırma Vapuru",
        shortDescription: "Tarihi bir başlangıcın simgesi.",
        theme: "History",
        locationHint: "İlkadım",
      },
    ],
    experiences: [],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },
  {
    id: "sinop",
    name: "Sinop",
    slogan: "Karadeniz’in sakin köşesi.",
    story:
      "Sinop, kalabalıktan uzak bir nefes gibidir. Liman etrafında yavaş yürüyüşler, küçük kafeler ve deniz kokusu; günün ritmini düşürür. Akşamları gün batımı, şehirle deniz arasında sessiz bir anlaşma yapar.",
    heroImage: null,
    themes: ["Sea", "Culture", "History"],
    highlights: [
      {
        id: "h-sinop-1",
        title: "Sinop Kalesi",
        shortDescription: "Denize karşı sur yürüyüşü.",
        theme: "History",
        locationHint: "Merkez",
      },
    ],
    experiences: [],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },
  {
    id: "ordu",
    name: "Ordu",
    slogan: "Teleferikle bulutlara.",
    story:
      "Ordu’da şehirden birkaç dakika uzaklaşınca manzara değişir. Teleferik yükseldikçe deniz geride kalır, yeşil öne çıkar. Sade ama güçlü bir Karadeniz deneyimi: kısa kaçamaklar, temiz hava ve sakin rotalar.",
    heroImage: null,
    themes: ["Nature", "Sea", "Adventure", "Food"],
    highlights: [
      {
        id: "h-ordu-1",
        title: "Boztepe",
        shortDescription: "Teleferik ile manzaraya çık.",
        theme: "Nature",
        locationHint: "Altınordu",
      },
    ],
    experiences: [],
    seasons: ["Spring", "Summer", "Autumn", "Winter"],
  },

  {
    id: "giresun",
    name: "Giresun",
    slogan: "Ada, yayla, fındık.",
    story: "TODO: hikaye",
    heroImage: null,
    themes: ["Nature", "Sea", "Food"],
    highlights: [],
    experiences: [],
    seasons: ["Spring", "Summer", "Autumn", "Winter"]
  },
  { id: "gumushane", name: "Gümüşhane", slogan: "Geçitler ve vadiler.", story: "TODO: hikaye", heroImage: null, themes: ["Nature", "Adventure", "History"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "bayburt", name: "Bayburt", slogan: "Sakin şehir, güçlü izler.", story: "TODO: hikaye", heroImage: null, themes: ["History", "Culture"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "corum", name: "Çorum", slogan: "Taşın hafızası.", story: "TODO: hikaye", heroImage: null, themes: ["History", "Culture", "Food"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "amasya", name: "Amasya", slogan: "Irmak kenarında masal.", story: "TODO: hikaye", heroImage: null, themes: ["History", "Culture", "Food"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "tokat", name: "Tokat", slogan: "Sokaklarda lezzet.", story: "TODO: hikaye", heroImage: null, themes: ["Food", "Culture", "History"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "kastamonu", name: "Kastamonu", slogan: "Orman, kanyon, köy.", story: "TODO: hikaye", heroImage: null, themes: ["Nature", "Adventure", "Culture"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "bartin", name: "Bartın", slogan: "Kıyıda sakinlik.", story: "TODO: hikaye", heroImage: null, themes: ["Sea", "Nature"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "karabuk", name: "Karabük", slogan: "Safran kokusu.", story: "TODO: hikaye", heroImage: null, themes: ["Culture", "History", "Food"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "zonguldak", name: "Zonguldak", slogan: "Mavi ve yeşil arası.", story: "TODO: hikaye", heroImage: null, themes: ["Sea", "Nature"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "duzce", name: "Düzce", slogan: "Şelaleler ve yaylalar.", story: "TODO: hikaye", heroImage: null, themes: ["Nature", "Adventure"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
  { id: "bolu", name: "Bolu", slogan: "Göl kenarında nefes.", story: "TODO: hikaye", heroImage: null, themes: ["Nature", "Food"], highlights: [], experiences: [], seasons: ["Spring", "Summer", "Autumn", "Winter"] },
];

export const seedDeals = [
  {
    id: "d-1",
    provinceId: "trabzon",
    title: "Uzungöl Hafta Sonu Kaçamağı",
    description: "2 kişilik konaklama + kahvaltı (MVP örnek).",
    priceText: "₺3.950 / 2 gece",
    startDate: "2025-12-20",
    endDate: "2026-03-31",
    theme: "Nature",
    contactCta: "WhatsApp ile iletişim",
  },
  {
    id: "d-2",
    provinceId: "rize",
    title: "Ayder Termal Günü",
    description: "Günübirlik termal + transfer (MVP örnek).",
    priceText: "₺1.250 / kişi",
    startDate: "2025-12-01",
    endDate: "2026-04-30",
    theme: "Nature",
    contactCta: "Arayın",
  },
  {
    id: "d-3",
    provinceId: "artvin",
    title: "Borçka Karagöl Fotoğraf Turu",
    description: "Rehberli kısa rota, sabah çıkış (MVP örnek).",
    priceText: "₺990 / kişi",
    startDate: "2026-03-01",
    endDate: "2026-11-15",
    theme: "Adventure",
    contactCta: "Form doldurun",
  },
];
